import Swup from 'swup';
// import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';

import SwupBodyClassPlugin from '@swup/body-class-plugin';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cards';
import 'swiper/css/free-mode';

// Import Alpine components
import './components/accordion.js';
import './components/rule.js';
import './components/spacer.js';
import './components/swiper.js';
import './components/cursorFollower.js';
import './components/cycle.js';
import './components/menu.js';
import fontTester from './components/fontTester.js';

// Register font tester globally
window.fontTester = fontTester;

window.isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;


const options = {
  // Let the browser handle pure hash links (e.g. <a href="#section">)
  // natively — swup's internal scrollToContent can fail after a transition.
  linkSelector: 'a[href]:not([href^="#"])',
  plugins: [
    // Syncs the <body> class (e.g. `is-home`) with the server-rendered HTML
    // on each SWUP transition so per-page CSS rules apply consistently.
    new SwupBodyClassPlugin()
  ]
};

// Register Alpine plugins before starting
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Make Alpine available globally
window.Alpine = Alpine;

const swup = new Swup(options); 

// Events
swup.hooks.on('content:replace', init);
swup.hooks.on('page:view', () => {
  // Update Alpine.js page state after navigation
  const wrapEl = document.querySelector('.wrap');
  if (wrapEl && wrapEl._x_dataStack) {
    const alpineData = wrapEl._x_dataStack[0];
    if (alpineData) {
      alpineData.page = location.pathname.split('/')[1];
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  l('ready');

  // Hide loader when page is ready
  const loader = document.getElementById('loader');
  if (loader) {
    loader.classList.add('loaded');
  }

  // Start Alpine.js
  Alpine.start();
  // checkCookie();
  init();
});

// Functions 

// Better console.log – only for local .test urls
function l(m) { 
  if(window.location.hostname.split('.').at(-1) == 'test') {
    console.log(m); 
  }
}

function init() {
  l('👍');
  // Initialize functions
  // isMobile = window.matchMedia('only screen and (max-width: 782px)').matches; 
  // console.log()
  // window.addEventListener('resize', () => { isMobile = window.innerWidth < 768; });
}